<template>
    <span>
        <i class="mr-1" :class="carrierChargesByClasses"/>
        <span v-html="carrier.chargesByLabel"/>
    </span>
</template>

<script>
export default {
    name: "CarrierChargesBy",
    props: {
        carrier: {
            required: true,
            type: Object,
        },
    },
    computed: {
        carrierChargesByClasses() {
            const chargesByClasses = {
                weight: "fas fa-weight-hanging text-info",
                lot: "fas fa-box text-warning",
                quantity: "fas fa-sort-numeric-up-alt text-success",
            };
            return chargesByClasses[this.carrier.chargesBy];
        },
    },
};
</script>

<style scoped>

</style>